import { render, staticRenderFns } from "./MetricList.vue?vue&type=template&id=2a8a0169&scoped=true&"
import script from "./MetricList.vue?vue&type=script&lang=js&"
export * from "./MetricList.vue?vue&type=script&lang=js&"
import style0 from "./MetricList.vue?vue&type=style&index=0&id=2a8a0169&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8a0169",
  null
  
)

export default component.exports